// extracted by mini-css-extract-plugin
export var text = "_6b-0";